(function () {
  'use strict';
  const STORAGE_KEY = 'marco-language';
  const supported = value => value === 'de' || value === 'en';
  let dictionary = { pairs: [], native_pairs: [] };
  try { dictionary = JSON.parse(document.getElementById('marco-language-data')?.textContent || '{}'); } catch (_) {}
  const normal = value => String(value ?? '').replace(/\s+/g, ' ').trim();
  const pairs = [...(dictionary.pairs || []), ...(dictionary.native_pairs || [])];
  const english = new Map(), german = new Map(), templates = [];
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const makePattern = value => {
    const parts = normal(value).split(/(\{\{\s*[\w.]+\s*\}\})/g);
    const names = [];
    const pattern = parts.map(part => {
      const match = part.match(/^\{\{\s*([\w.]+)\s*\}\}$/);
      if (match) { names.push(match[1]); return /^(count|quantity|index|number)$/.test(match[1]) ? '([0-9]+(?:[.,][0-9]+)?)' : '(.+?)'; }
      return escapePattern(part);
    }).join('');
    return { expression: new RegExp('^' + pattern + '$'), names };
  };
  for (const pair of pairs) {
    if (typeof pair.en !== 'string' || typeof pair.de !== 'string') continue;
    const en = normal(pair.en), de = normal(pair.de);
    if (!en || !de || /<\/?[a-z][^>]*>/i.test(en + de)) continue;
    if (/\{\{/.test(en + de)) { const specificity = Math.min(en.replace(/\{\{.*?\}\}/g,'').length,de.replace(/\{\{.*?\}\}/g,'').length); if(specificity>=1)templates.push({ key:pair.key || '',en, de, specificity,enPattern: makePattern(en), dePattern: makePattern(de) }); continue; }
    if (!english.has(en)) english.set(en, de);
    if (!german.has(de)) german.set(de, en);
  }
  for (const [en, de] of [
    ['Language', 'Sprache'], ['English', 'Englisch'], ['Source Code', 'Quellcode'],
    ['One Brand. Three Worlds.', 'Eine Marke. Drei Welten.'],
    ['MARCO · Your Gaming World', 'MARCO · Deine Gaming-Welt'],
    ['Three areas. Your MARCO.', 'Drei Bereiche. Dein MARCO.'],
    ['Private Preview', 'Private Vorschau'], ['Private preview', 'Private Vorschau'],
    ['Active', 'Aktiv'], ['Draft', 'Entwurf'], ['Archived', 'Archiviert'],
    ['Search', 'Suche'], ['All', 'Alle'], ['Physical Product', 'Physisches Produkt'],
    ['Email', 'E-Mail'], ['Email Marco at', 'Schreibe an'], ['Shipping', 'Versand'], ['shipping', 'Versand'],
    ['calculated at checkout.', 'Berechnung beim Checkout.'], ['Taxes included. Discounts and', 'Steuern enthalten. Rabatte und'],
    ['Digital product', 'Digitales Produkt'], ['No shipping', 'kein Versand'], ['not our selling price', 'kein MARCO-Verkaufspreis'],
    ['Share', 'Teilen'], ['Close share', 'Teilen schließen']
  ]) { english.set(en, de); if (!german.has(de)) german.set(de, en); }
  templates.sort((a,b)=>b.specificity-a.specificity);
  let language = 'de';
  let requested = '', saved = '';
  try { requested = new URL(location.href).searchParams.get('language') || ''; } catch (_) {}
  try { saved = localStorage.getItem(STORAGE_KEY) || ''; } catch (_) {}
  language = supported(requested) ? requested : supported(saved) ? saved : 'de';
  document.documentElement.lang = language;
  const textState = new WeakMap(), attributeState = new WeakMap();
  let applying = false, scheduled = false, observer;
  const skipped = element => !element || !!element.closest('script,style,textarea,[data-marco-no-translate],[data-marco-language-control],[data-marco-product-title],.product__title,.card__heading');
  const money = (value, target) => {
    if (!/€|EUR/.test(value)) return null;
    const match = value.match(/^(?:€\s*)?([\d.,]+)\s*(?:€)?(?:\s*EUR)?$/);
    if (!match) return null;
    let number = match[1];
    if (number.includes(',') && number.includes('.')) number = number.lastIndexOf(',') > number.lastIndexOf('.') ? number.replace(/\./g, '').replace(',', '.') : number.replace(/,/g, '');
    else if (number.includes(',')) number = number.replace(',', '.');
    const amount = Number(number);
    if (!Number.isFinite(amount)) return null;
    return new Intl.NumberFormat(target === 'de' ? 'de-AT' : 'en-IE', { style: 'currency', currency: 'EUR' }).format(amount) + (/EUR$/.test(value) ? ' EUR' : '');
  };
  function translate(value, target = language, depth = 0) {
    const source = normal(value);
    if (!source || depth > 5) return source;
    if (english.has(source)) return target === 'de' ? english.get(source) : source;
    if (german.has(source)) return target === 'en' ? german.get(source) : source;
    const nativeTitle = source.match(/^(.*)( [-–] MARCO)$/);
    if (nativeTitle) return (english.has(nativeTitle[1]) || german.has(nativeTitle[1]) ? translate(nativeTitle[1], target, depth + 1) : nativeTitle[1]) + nativeTitle[2];
    const price = money(source, target);
    if (price !== null) return price;
    let match;
    if ((match = source.match(/^(?:Search|Suche): (.*)$/))) return (target === 'de' ? 'Suche: ' : 'Search: ') + match[1];
    if ((match = source.match(/^(.*?) · (?:Search|Suche): (.*)$/))) return translate(match[1], target, depth + 1) + (target === 'de' ? ' · Suche: ' : ' · Search: ') + match[2];
    if ((match = source.match(/^(.+) — (product image|view details|image (\d+)|Produktbild|Details anzeigen|Bild (\d+))$/))) {
      const suffix = /product image|Produktbild/.test(match[2]) ? (target === 'de' ? 'Produktbild' : 'product image') : /view details|Details anzeigen/.test(match[2]) ? (target === 'de' ? 'Details anzeigen' : 'view details') : (target === 'de' ? 'Bild ' : 'image ') + (match[3] || match[4]);
      return match[1] + ' — ' + suffix;
    }
    if (source.length <= 600) for (const template of templates) {
      for (const key of ['en', 'de']) {
        const spec = template[key + 'Pattern'];
        const values = source.match(spec.expression);
        if (!values) continue;
        const variables = Object.fromEntries(spec.names.map((name, index) => [name, values[index + 1]]));
        const amount = Number(variables.count ?? variables.quantity);
        if (template.key.endsWith('.one') && Number.isFinite(amount) && amount !== 1) continue;
        if (template.key.endsWith('.other') && amount === 1) continue;
        return template[target].replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, name) => variables[name] ?? '');
      }
    }
    if (source.includes(' · ')) return source.split(' · ').map(part => translate(part, target, depth + 1)).join(' · ');
    if ((match = source.match(/^(?:Product catalogue checked on|Produktkatalog geprüft am) (.+)\.$/))) return (target === 'de' ? 'Produktkatalog geprüft am ' : 'Product catalogue checked on ') + match[1] + '.';
    if ((match = source.match(/^(\d+) (?:products?|Produkte?)$/))) return target === 'de' ? match[1] + (match[1] === '1' ? ' Produkt' : ' Produkte') : match[1] + (match[1] === '1' ? ' product' : ' products');
    if ((match = source.match(/^(\d+) (?:of|von) (\d+) (?:products?|Produkten|Produkte?)(.*)$/))) return match[1] + (target === 'de' ? ' von ' : ' of ') + match[2] + (target === 'de' ? (match[2] === '1' ? ' Produkt' : ' Produkten') : (match[2] === '1' ? ' product' : ' products')) + (match[3] ? ' ' + translate(match[3], target, depth + 1) : '');
    if ((match = source.match(/^(\d+) (?:products to explore|Produkte zum Entdecken)$/))) return match[1] + (target === 'de' ? ' Produkte zum Entdecken' : ' products to explore');
    if ((match = source.match(/^(?:Copy this product link|Kopiere diesen Produktlink): (.*)$/))) return (target === 'de' ? 'Kopiere diesen Produktlink: ' : 'Copy this product link: ') + match[1];
    if ((match = source.match(/^(?:showing|angezeigt:) (\d+)$/))) return (target === 'de' ? 'angezeigt: ' : 'showing ') + match[1];
    if ((match = source.match(/^(?:Show (\d+) more|(\d+) weitere anzeigen)$/))) return target === 'de' ? (match[1] || match[2]) + ' weitere anzeigen' : 'Show ' + (match[1] || match[2]) + ' more';
    if ((match = source.match(/^(All|Active|Draft|Archived|Alle|Aktiv|Entwurf|Archiviert) \((\d+)\)$/))) return translate(match[1], target, depth + 1) + ' (' + match[2] + ')';
    if ((match = source.match(/^(?:Book|Band) (\d+)$/))) return (target === 'de' ? 'Band ' : 'Book ') + match[1];
    if ((match = source.match(/^(?:Book|Band) (\d+) (?:of The Varrow Seams as an English-language EPUB download\. No printed book is included\.|von The Varrow Seams als englischsprachiger EPUB-Download\. Ein gedrucktes Buch ist nicht enthalten\.)$/))) return target === 'de' ? 'Band ' + match[1] + ' von The Varrow Seams als englischsprachiger EPUB-Download. Ein gedrucktes Buch ist nicht enthalten.' : 'Book ' + match[1] + ' of The Varrow Seams as an English-language EPUB download. No printed book is included.';
    if ((match = source.match(/^(?:Search|Suche): (.*)$/))) return (target === 'de' ? 'Suche: ' : 'Search: ') + match[1];
    if ((match = source.match(/^(?:Manufacturer reference|Hersteller-Referenzpreis): (.*)$/))) return (target === 'de' ? 'Hersteller-Referenzpreis: ' : 'Manufacturer reference: ') + translate(match[1], target, depth + 1);
    if ((match = source.match(/^(?:Private preview · Product catalogue checked on|Private Vorschau · Produktkatalog geprüft am) (.+)\.$/))) return (target === 'de' ? 'Private Vorschau · Produktkatalog geprüft am ' : 'Private preview · Product catalogue checked on ') + match[1] + '.';
    return source;
  }
  function translateText(node) {
    if (skipped(node.parentElement) || !node.nodeValue.trim()) return;
    const current = node.nodeValue, previous = textState.get(node);
    const original = previous && previous.last === current ? previous.original : current;
    const prefix = original.match(/^\s*/)[0], suffix = original.match(/\s*$/)[0];
    const next = prefix + translate(original) + suffix;
    textState.set(node, { original, last: next });
    if (node.nodeValue !== next) node.nodeValue = next;
  }
  function translateAttributes(element) {
    if (skipped(element)) return;
    const state = attributeState.get(element) || new Map();
    for (const name of ['aria-label', 'alt', 'placeholder', 'title']) {
      const current = element.getAttribute(name);
      if (current === null || !current.trim()) continue;
      const previous = state.get(name), original = previous && previous.last === current ? previous.original : current;
      const next = translate(original);
      state.set(name, { original, last: next });
      if (current !== next) element.setAttribute(name, next);
    }
    attributeState.set(element, state);
  }
  function updateControls() {
    document.querySelectorAll('[data-marco-language-control]').forEach(control => { const label = language === 'de' ? 'Sprache' : 'Language'; if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label); });
    document.querySelectorAll('[data-marco-language]').forEach(button => {
      const selected = button.getAttribute('data-marco-language') === language;
      if (button.getAttribute('aria-pressed') !== String(selected)) button.setAttribute('aria-pressed', String(selected));
      const title = button.getAttribute('data-marco-language') === 'de' ? 'Deutsch' : 'English';
      if (button.getAttribute('title') !== title) button.setAttribute('title', title);
    });
  }
  function apply(root = document) {
    if (applying || !root) return;
    applying = true;
    try {
      if (root.nodeType === 3) translateText(root);
      else {
        if (root.nodeType === 1) translateAttributes(root);
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) translateText(node);
        root.querySelectorAll?.('[aria-label],[alt],[placeholder],[title]').forEach(translateAttributes);
      }
      document.documentElement.lang = language;
      updateControls();
      const title = translate(document.title);
      if (title !== document.title) document.title = title;
    } finally { applying = false; }
  }
  function updateAddress() {
    if (!/^https?:$/.test(location.protocol)) return;
    try { const url = new URL(location.href); url.searchParams.set('language', language); history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
  }
  function setLanguage(next) {
    if (!supported(next)) return;
    const changed = next !== language, focused = document.activeElement;
    language = next;
    document.documentElement.lang = language;
    try { localStorage.setItem(STORAGE_KEY, language); } catch (_) {}
    updateAddress();
    if (changed) document.dispatchEvent(new CustomEvent('marco:language', { detail: { language } }));
    apply(document);
    if (focused?.isConnected && typeof focused.focus === 'function') focused.focus({ preventScroll: true });
  }
  window.MARCOLanguage = { get language() { return language; }, translate, apply, setLanguage };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-marco-language]');
    if (!button) return;
    event.preventDefault();
    setLanguage(button.getAttribute('data-marco-language'));
  });
  function boot() {
    apply(document);
    if (typeof MutationObserver !== 'function') return;
    observer = new MutationObserver(records => {
      if (scheduled || !records.length) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; apply(document.body); });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt', 'placeholder', 'title'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();

